module.exports = __webpack_public_path__ + "6b0523b4f37f9004ef8c4f85bedf8d44.svg";